export default __webpack_public_path__ + "static/media/icon-instagram.46cfe17c.svg";